<template>
    <div v-show="show" class="bg">
        <div class="box-container">
            <div class="title">
                <p>编辑封面-封面截取</p>
            </div>
            <div class="photoEdit-container">
                <div class="left-container">
                    <img class="cutPic" ref="cutPicArea" :src="picUrl" alt="">
                </div>
                <div class="right-container">
                    <p class="title">预览</p>
                    <img class="cover" :src="imgUrl" alt="">
                    <!-- <div :style="'background-image:'" class="cover"></div> -->
                    <p class="line"></p>
                    <div v-if="res.type != 'five_star_sports_cms'" class="tips">
                        <img src="../../assets/img/mediaPublish/notice.png" alt="">
                        <p>尺寸要求：{{sizeName}}</p>
                    </div>
                    <div v-else class="tipsSelect">
                        <p>当前比例：</p>
                        <div>
                            <i @click="setRatio('4/3')" :class="{on: sportIndex == '4/3'}"></i>
                            <span>4:3</span>
                        </div>
                        <div>
                            <i @click="setRatio('3/4')" :class="{on: sportIndex == '3/4'}"></i>
                            <span>3:4</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns-container">
                <p @click="submitCut" class="btn on">确定</p>
                <p v-if="res.type != 'dy'" @click="close" class="btn">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
    import common from '@common/common'
    import {apis,websocketjs,peMiddle,fabric,tuiCodeSnippet,FileSaver,colorpicker,tuiImageEditor,cropper} from '@common/config'
    import script from '../script'
    import vClickOutside from "v-click-outside";

    export default {
        data() {
            return {
                sizeName: '16：9',
                width: 16,
                height: 9,
                show: true,
                res: {},
                c: null,
                cropper: null,
                picUrl: '',
                imgUrl: require("@assets/img/common/default.png"),
                appId: '',
                appSecret: '',
                uploadUrl: '',
                pic: {
                    // 图片部分数据模型
                    types: [],
                    assets: []
                },
                video: {
                    // 视频部分数据模型
                    types: [],
                    assets: []
                },
                audio: {
                    // 音频部分数据模型
                    types: [],
                    assets: []
                },
                _XN_upCfg: null,
                sportIndex: '4/3'
            }
        },
        methods: {
            open(res, c) {
                console.log(res)
                if(res.type == 'b_plus'){
                    this.sizeName = '16：9'
                }else if(res.type == 'dy'){
                    this.sizeName = '150：200'
                }else if(res.type == 'bilibili'){
                    this.sizeName = '4：3'
                }else{
                    this.sizeName = '16：9'
                }
                this.res = res || ''
                this.c = c;
                this.picUrl = res.url;
                this.show = true;
                this.imgUrl = this.$_syscfg.default_img;
                if(this.cropper){
                    this.cropper.destroy()
                    this.cropper = null;
                }
                this.getConfig();
                this.getAsperaConfig();
                this.loaded()
            },
            close() {
                this.show = false;
                this.c(false)
            },
            checkFileType(f) {
                // 检查文件类型
                let type = "";
                let ext = f.path.split(".").pop() || f.name.split(".").pop();
                ext = ext.toLowerCase();

                if (this.pic.types.indexOf(ext) > -1) {
                    type = 1;
                } else if (this.video.types.indexOf(ext) > -1) {
                    type = 2;
                } else if (this.audio.types.indexOf(ext) > -1) {
                    type = 3;
                }

                return type;
            },
            getConfig() {
                return common.getFileConfigs()
                .then(r => {
                    this.appId = r.app_id
                    this.appSecret = r.app_secret
                    this.uploadUrl = r.url
                })
            },
            getAsperaConfig() {
                // 获取aspera上传配置
                return common.myFetch(apis.File_Aspera)
                .then(r => {
                    if (r) {
                        const types = r.file_format;
                        this.pic.types = types.image;
                        this.video.types = types.video;
                        this.audio.types = types.audio;

                        this._XN_upCfg = {
                            asperaPath: r.aspera_path,
                            httpPath: r.original_path,
                            fileNameId: r.filename_id
                        }
                    }
                })
            },
            submitCut() {
                let file = this.dataURLtoBlob(this.imgUrl)
                this.streamUpload(this.res.title,file)
            },
            dataURLtoBlob(dataurl) {
                var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime
                });
            },
            streamUpload(name, file) {
                console.log(file)
                var that = this;
                var upConfig = this._XN_upCfg
                var filename = name
                var uniname = common.uniKey()
                var platform = common.getPlatform()
                var ext = file.type.split('/').pop()
                var fileNameId = upConfig.fileNameId
                var httpPath = upConfig.httpPath
                var path = httpPath + '/' + fileNameId + platform + uniname + '.' + ext

                const info = { 
                    targetPath: path,
                    appId: this.appId,
                    appSecret: this.appSecret
                };

                var _url = this.uploadUrl + "/streamUpload?targetPath="+info.targetPath+"&appId="+info.appId+"&appSecret="+info.appSecret;
                var _xhr = new XMLHttpRequest;

                _xhr.ontimeout = function () {
                    console.error('The request for ' + _url + ' timed out.');
                };

                _xhr.onreadystatechange = function() {
                    console.log(_xhr.responseText)
                    if (_xhr.readyState != 4 || _xhr.status < 200)
                    return false;
                    let data = JSON.parse(_xhr.responseText)
                    if(data.success){
                        console.log(data)
                        data.targetPath = data.path;
                        data.name = name;
                        that.addAssetsToPage([data])
                    }else{
                        this.$imgLoading.close()
                        this.showSelect = false;
                        this.showFail = true;
                        this.canEditImg = true
                        this.alertWord = '网络连接超时'
                    }
                }

                _xhr.timeout = 60 * 1000;
                _xhr.open("POST", _url, !0);
                _xhr.send(file);
            },
            async addAssetsToPage(data) {
                console.log('更新到接口', data);
                const filelist = [];
                data.forEach(i => {
                    console.log(i)
                    const type = this.checkFileType(i);
                    // 将文件名改为截取前40位加后缀名
                    const fileName = i.pureName || i.title || i.filename || i.name || "";
                    const nameParts = fileName.split(".")[0];
                    const ext = i.path.split('/').pop().split('.').pop();
                    let nameLeft = nameParts;
                    nameLeft = nameLeft.substr(0, 40);
                    const filetitle = `${nameLeft}.${ext}`;
                    console.log(filetitle)

                    let file = {};

                    file = {
                        type: type,
                        title: filetitle,
                        path: i.targetPath || i.path,
                        subject_id: this.res.id,
                        subject_type: 5
                    };
                    

                    filelist.push(file);
                });

                const info = { file_info: JSON.stringify(filelist) };
                return common.myFetch(apis.File_add, info).then(r => {
                    if (r) {
                        console.log(r)
                        this.c(r)
                        this.close()
                    }else{
                        this.c(false)
                        this.close()
                    }
                });
            },
            loaded() {
                return this.loadCropper().then(() => {
                    this.initPicEdit(this.picUrl)
                })
            },
            loadCropper() {
                return common.load(cropper)
            },
            setRatio(ratio) {
                this.sportIndex = ratio;
                if(ratio == '4/3'){
                    this.cropper.setAspectRatio(4 / 3);
                    this.cropper.crop()
                    this.cutDone()
                }else{
                    this.cropper.setAspectRatio(3 / 4);
                    this.cropper.crop()
                    this.cutDone()
                }
            },
            initPicEdit(url) {
                var that = this;
                if(this.cropper){
                    this.cropper.destroy()
                }
                this.cropper = null
                var options = {
                    autoCrop: true,
                    zoomOnWheel: false,
                    autoCropArea: 1,
                    ready: function (e) {
                        console.log(that.res.type)
                        if(that.res.type == 'b_plus'){
                            that.cropper.setAspectRatio(16 / 9)
                        }else if(that.res.type == 'dy'){
                            that.cropper.setAspectRatio(150 / 200)
                        }else if(that.res.type == 'five_star_sports_cms'){
                            that.cropper.setAspectRatio(4 / 3)
                        }else if(that.res.type == 'bilibili'){
                            that.cropper.setAspectRatio(4 / 3)
                        }else{
                            that.cropper.setAspectRatio(16 / 9)
                        }
                        that.cropper.crop()
                        that.cutDone()
                    },
                    zoom: function (e) {
                        console.log(e.type, e.detail.ratio);
                    },
                    cropend: function (e) {
                        //操作动作结束
                        console.log(e.type, e.detail.action);
                        that.cutDone()
                    }
                };
                this.$refs.cutPicArea.src = this.picUrl
                var cropper = new Cropper(this.$refs.cutPicArea, options);
                this.cropper = cropper;
            },
            cutDone() {
                var imgUrl = this.cropper.getCroppedCanvas().toDataURL('image/jpeg');
                this.imgUrl = imgUrl;
                // console.log(imgUrl)
            }
        },
        mounted() {
            
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(50, 59, 75, 0.3);
    backdrop-filter: blur(1.6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000003;

    .box-container {
        width: 880px;
        height: 490px;
        padding: 20px 30px 24px;
        background: #F9F9F9;
        border-radius: 4px;

        &>.title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            p {
                font-size: 24px;
                color: #323B4B;
                line-height: 33px;
                font-weight: bold;
            }
        }

        .photoEdit-container {
            display: flex;
            flex-direction: row;
            width: 100%;
            margin-bottom: 40px;

            .left-container {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 570px;
                height: 321px;
                margin-right: 30px;

                .cutPic {
                    max-width: 100%;
                    max-height: 100%;
                    height: auto;
                }
            }

            .right-container {
                display: flex;
                flex-direction: column;

                .title {
                    font-size: 14px;
                    line-height: 20px;
                    color: #323B4B;
                    margin-bottom: 14px;
                    font-weight: bold;
                }

                .cover {
                    width: 220px;
                    height: 124px;
                    border-radius: 4px;
                    background-repeat: no-repeat;
                    background-position: center center;
                    background-size: contain;
                    object-fit: contain;
                }

                .line {
                    width: 220px;
                    height: 1px;
                    border: 1px solid #DCDCDC;
                    box-sizing: border-box;
                    margin: 16px 0 13px
                }

                .tips {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    img {
                        width: 14px;
                        height: 14px;
                        margin-right: 8px;
                    }

                    p {
                        font-size: 14px;
                        line-height: 20px;
                        color: #323B4B;
                    }
                }

                .tipsSelect {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    p {
                        font-size: 14px;
                        line-height: 20px;
                        color: #323B4B;
                        margin-right: 10px;
                        font-weight: bold;
                    }

                    div {
                        display: flex;
                        align-items: center;
                        margin-right: 20px;

                        &:nth-last-of-type(1) {
                            margin-right: 0;
                        }

                        i {
                            display: block;
                            width: 16px;
                            height: 16px;
                            background: rgba(130, 145, 145, 0.15);
                            border-radius: 20px;
                            margin-right: 8px;
                            user-select: none;
                            cursor: pointer;

                            &.on {
                                position: relative;
                                background: rgba(65, 180, 140, 1);

                                &::after {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    display: block;
                                    content: '';
                                    width: 6px;
                                    height: 6px;
                                    background: #FFFFFF;
                                    border-radius: 20px;
                                }
                            }
                        }

                        span {
                            font-weight: 500;
                            font-size: 13px;
                            color: #323B4B;
                        }
                    }
                }
            }
        }

        .btns-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-top: 24px;

            .btn {
                width: 120px;
                height: 32px;
                background: #B9C3C3;
                border-radius: 4px;
                font-size: 14px;
                line-height: 32px;
                font-weight: bold;
                text-align: center;
                color: #FFF;
                user-select: none;
                cursor: pointer;

                &.on {
                    background: #41B48C;
                    margin-right: 20px;
                }
            }
        }
    }
}
</style>